export const ComparisonResult = {
	changedOldVersion: "(Było)",
	changedNewVersion: "(Jest)",
	changed: "(Zmieniony)",
	added: "(Nowy)",
	removed: "(Usunięty)",
	same: ""
};